import GoogleMapReact from 'google-map-react';
import React, {useEffect, useRef} from 'react';
import {VendingMachineInformation} from "./gen";
import VendingMachineMarker from "./vending_machine_marker";

interface Props {
    vendingMachines:VendingMachineInformation[]
    selectedVendingMachine:VendingMachineInformation|null
    onSelectVendingMachine:Function
}

function VendingMachineMap(props:Props) {
    const mapRef = useRef<any>(null);
    const mapsRef = useRef<any>(null);

    const fitBounds = (map: any, maps: any) => {
        if (props.vendingMachines.length === 0) return;
        const bounds = new maps.LatLngBounds();
        props.vendingMachines.forEach((vm) => {
            bounds.extend(new maps.LatLng(vm.latitude, vm.longitude));
        });
        map.fitBounds(bounds);
    };

    useEffect(() => {
        if (mapRef.current && mapsRef.current && props.selectedVendingMachine === null) {
            fitBounds(mapRef.current, mapsRef.current);
        }
    }, [props.vendingMachines]); // eslint-disable-line react-hooks/exhaustive-deps

    const markers = props.vendingMachines.map((vendingMachine, index) => (
        <VendingMachineMarker key={index} lat={vendingMachine.latitude ?? 0} lng={vendingMachine.longitude ?? 0} vendingMachine={vendingMachine} isSelected={props.selectedVendingMachine === vendingMachine} onSelectVendingMachine={props.onSelectVendingMachine}/>
    ));

    let center = { lat: -37.8136, lng: 144.9631 }; // Melbourne default
    let zoom = 10;

    if (props.selectedVendingMachine !== null) {
        center = {
            lat: props.selectedVendingMachine.latitude ?? -37.8136,
            lng: props.selectedVendingMachine.longitude ?? 144.9631
        };
        zoom = 15;
    }

    return (
        <GoogleMapReact
            bootstrapURLKeys={{ key:"AIzaSyB6H46h4veKd70Kya-I6g9vfOAy7H1FW5Y", libraries: ['places'] }}
            zoom={zoom}
            center={center}
            yesIWantToUseGoogleMapApiInternals
            onGoogleApiLoaded={({ map, maps }) => {
                mapRef.current = map;
                mapsRef.current = maps;
                fitBounds(map, maps);
            }}
        >
            {markers}
        </GoogleMapReact>
    );
}

export default VendingMachineMap;
